<template>
  <!-- 选择地址弹出层 -->
  <van-popup
    v-model="showPicker"
    round
    position="bottom"
  >
    <div class="popup-box">
      <div class="title-box">
        <div>{{ type === 'start' ? '修改起点' : '修改终点' }}</div>
        <van-icon
          name="clear"
          color="#E9E9E9"
          size="20"
          @click="close"
        />
      </div>
      <van-search
        v-model="searchKey"
        placeholder="请输入地名进行搜索"
        class="search-input"
        clearable
        @input="changeSearch"
      />
      <div class="address-box">
        <div
          class="address-item"
          :class="{active: activeIndex === index}"
          v-for="(item, index) in addressList"
          :key="index"
          @click="selectAddress(index)"
        >
          <div class="item-left">
            <div class="item-icon">
              <van-icon name="location" />
            </div>
            <div>
              <div class="item-name">{{ item.name }}</div>
              <div class="item-address">{{ item.pname || '' }}{{ item.cityname || '' }}{{ item.address }}</div>
            </div>
          </div>
        </div>
        <van-empty
          v-if="addressList.length === 0"
          image="search"
          description="请输入详细的省市地名进行搜索"
        />
      </div>
      <van-row>
        <van-col
          span="22"
          offset="1"
        >
          <van-button
            type="info"
            block
            :disabled="activeIndex < 0"
            @click="confirm"
          >确定</van-button>
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
import { debounce } from 'lodash';
export default {
  data() {
    return {
      type: '',
      searchKey: '',
      showPicker: false,
      placeSearch: null,
      addressList: [],
      activeIndex: -1,
      currentPosition: null,
      cityCode: '',
      taskStatus: '',
      taskNo: ''
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    open(type) {
      this.type = type;
      this.initSearch();
      this.showPicker = true;
    },
    close() {
      this.showPicker = false;
      this.searchKey = '';
      this.addressList = [];
      this.activeIndex = -1;
    },
    confirm() {
      this.$emit('confirm', this.type, this.addressList[this.activeIndex]);
      this.close();
    },
    initSearch() {
      const _this = this;
      AMap.service(['AMap.PlaceSearch'], function() {
        _this.placeSearch = new AMap.PlaceSearch({
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          extensions: 'all',
          citylimit: false
        });
      });
    },
    changeSearch: debounce(function(val) {
      if (this.placeSearch) {
        this.activeIndex = -1;
        const _this = this;
        this.placeSearch.search(val, (status, result) => {
          console.log(result, 'result');
          _this.addressList = result.poiList ? (result.poiList.pois || []) : [];
        });
      }
    }, 300),
    selectAddress(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-box{
  padding: 16px 8px 0;
}
.title-box{
  display: flex;
  justify-content: space-between;

  padding: 8px 12px;

  font-size: 16px;
}
.search-input{
  .van-search__content{
    border-radius: 8px;
    .van-cell{
      padding: 8px 8px 8px 0;
    }
  }
}
.address-box {
  overflow-y: auto;

  height: 45vh;
  .address-item{
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 16px 12px;

    letter-spacing: -0.38px;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;

    &.active{
      color: #1989fa;
      .item-icon,
      .item-left,
      .item-name,
      .item-address,
      .item-distance{
        color: #1989fa;
      }
    }

    .item-icon{
      margin-right: 12px;

      color: #B7BFC8;
    }

    .item-left{
      display: flex;
      align-items: center;

      margin-right: 12px;
    }

    .item-name{
      color: #3B3B3B;

      font-size: 15px;
      font-weight: 600;
    }

    .item-address{
      padding-top: 8px;

      color: #8D8D8D;

      font-size: 13px;
      font-weight: 400;
    }

    .item-distance{
      flex: 80px 0 0;

      text-align: right;

      color: #B6B6B6;

      font-size: 12px;
      font-weight: 400;
    }
  }
}
.van-row{
  padding: 10px 0;
}
</style>
